import { useState } from 'react'
import { TZDate } from '@date-fns/tz'

import { EMPTY_OBJECT } from '../../../../constants/common'
import { useDateLocale, useTimeZone } from '../../../../hooks'

import {
  getCalendarGridDropDay,
  getCalendarGridDropPreviewItem,
  getIsCalendarGridItemMovedToDay,
  getIsCalendarGridPreviewItemMoved,
  getIsCalendarGridPreviewItemUnchanged,
} from './useCalendarGridDragDrop.utils'

export function useCalendarGridDragDrop({ onMoveItem, onMoveItemTime }) {
  const [previewItem, setPreviewItem] = useState(null)

  const locale = useDateLocale()
  const timezone = useTimeZone()

  function handleDragMove(event) {
    const nextItem = getCalendarGridDropPreviewItem({
      event,
      locale,
      timezone,
    })

    setPreviewItem(currentItem =>
      getIsCalendarGridPreviewItemUnchanged({ currentItem, nextItem })
        ? currentItem
        : nextItem
    )
  }

  function handleDragCancel() {
    setPreviewItem(null)
  }

  function handleDragEnd(event) {
    const { day: sourceDay, item } = event.active.data.current ?? EMPTY_OBJECT

    const day = getCalendarGridDropDay(event)

    const droppedItem = getCalendarGridDropPreviewItem({
      event,
      locale,
      timezone,
    })

    setPreviewItem(null)

    if (getIsCalendarGridPreviewItemMoved({ item, previewItem: droppedItem })) {
      onMoveItemTime(item, new TZDate(droppedItem.start, timezone))
    } else if (getIsCalendarGridItemMovedToDay({ day, item, sourceDay })) {
      onMoveItem?.(item, day)
    }
  }

  return {
    handleDragCancel,
    handleDragEnd,
    handleDragMove,
    previewItem,
  }
}
